import { DashedFocusBorder } from 'components/Common/DashedFocusBorder';
import styled from 'styled-components';
import { DropZoneDimensions } from './JRCInputImage';

export const InputFileWrapper = styled.div`
    display: none;
`;

export const Grid = styled.div<{ position?: 'right' | 'bottom'; columnCount: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.columnCount + (props.position === 'right' ? 2 : 0)}, 1fr);
    ${(props) => props.position === 'right' && 'grid-template-rows: 1fr 1fr'};
    gap: 8px;
`;

export const DropZone = styled.div<{
    position?: 'right' | 'bottom';
    columnCount: number;
    dzDimensions?: DropZoneDimensions;
}>`
    position: relative;
    grid-column: ${(props) => (props.position === 'right' ? '1 / 3' : `1 / ${props.columnCount + 1}`)};
    ${(props) => props.position === 'right' && 'grid-row: 1 / 3'};
    border-radius: 8px;
    border: 1.5px dashed ${(props) => props.theme.color.grey2};
    z-index: 0;
    ${({ dzDimensions }) => {
        if (!dzDimensions) {
            return '';
        }
        return `width: ${dzDimensions.width}px;\nheight: ${dzDimensions.height}px;`;
    }}
`;

export const ReadOnlyImg = styled.img`
    border-radius: 8px;
    border: 1.5px dashed ${(props) => props.theme.color.grey2};
    max-height: 200px;
    max-width: 100%;
`;

export const DropZoneButton = styled.button<{ aspectRatio?: number | undefined }>`
    width: 100%;
    aspect-ratio: ${(props) => props.aspectRatio || '1'} / 1;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.color.grey0};

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        transition: all 0.2s;
        z-index: 1;
        pointer-events: none;
    }

    &.is-dragged::after,
    &.is-loading::after {
        background-size: 50px 50px;
        animation: move 2s linear infinite;
        border-radius: 8px;
        overflow: hidden;

        @keyframes move {
            0% {
                background-position: 0 0;
            }
            100% {
                background-position: 50px 50px;
            }
        }

        background-image: linear-gradient(
            -45deg,
            var(--color-1) 25%,
            var(--color-2) 25%,
            var(--color-2) 50%,
            var(--color-1) 50%,
            var(--color-1) 75%,
            var(--color-2) 75%,
            var(--color-2)
        );
    }

    &.is-dragged::after {
        --color-1: ${(props) => props.theme.color.grey2}77;
        --color-2: ${(props) => props.theme.color.white}77;
    }

    &.is-loading::after {
        --color-1: ${(props) => props.theme.color.greenL90}99;
        --color-2: ${(props) => props.theme.color.greenL80}ee;
    }

    ${DashedFocusBorder()}
`;

export const DropZoneImage = styled.img`
    max-height: 100%;
    max-width: 100%;
    border-radius: 8px;
`;

export const ImageButton = styled.button<{ aspectRatio?: number }>`
    border-radius: 8px;
    ${(props) => (props.aspectRatio ? `aspect-ratio: ${props.aspectRatio} / 1;` : '')}
    box-sizing: border-box;
    overflow: hidden;

    img {
        max-width: 100%;
        object-fit: contain;
    }

    ${DashedFocusBorder()}
`;

export const Img = styled.img`
    transition: all 0.4s;
    :hover {
        transform: scale(1.1);
    }
`;
